module.exports = "/static/images/ljn-google-map-screenshot.png";